import { AZURE_COLUMN_ID } from "../../../constants";
import IntegrationsAzureTableDropdownActionsCell from "./DropdownActionsCell";
import IntegrationsAzureTableNameCell from "./NameCell";
import IntegrationsAzureTableSpaceCell from "./SpaceCell";
import IntegrationsAzureTableTypeCell from "./TypeCell";

export const INTEGRATIONS_AZURE_TABLE_CELLS = {
  [AZURE_COLUMN_ID.TYPE]: IntegrationsAzureTableTypeCell,
  [AZURE_COLUMN_ID.NAME]: IntegrationsAzureTableNameCell,
  [AZURE_COLUMN_ID.SPACE]: IntegrationsAzureTableSpaceCell,
  [AZURE_COLUMN_ID.DROPDOWN]: IntegrationsAzureTableDropdownActionsCell,
};
